import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

/** Clickable header with a sort arrow — right-aligned for numeric columns (the
 *  default), `align="left"` for text columns in the same table. Every header shows
 *  a faint up/down arrow until it is the sorted column, so it is visible that the
 *  column CAN be sorted; the sorted column shows its direction in the accent colour.
 *
 *  Generic over the column key type `C` (a string union such as
 *  `'value' | 'points' | 'contribution'`) so call sites keep their exact
 *  sort-key typing. `label` accepts any React node, which subsumes plain
 *  string labels. */
export function NumSortTh<C extends string>({
  label, col, sortKey, sortDir, onSort, sticky, align = 'right',
}: {
  label: React.ReactNode;
  col: C;
  sortKey: C;
  sortDir: 'asc' | 'desc';
  onSort: (col: C) => void;
  /** Pins the header to the top of a scrolling table region (header freeze). */
  sticky?: boolean;
  align?: 'left' | 'right';
}) {
  const active = sortKey === col;
  return (
    <th
      className={`whitespace-nowrap px-3 py-2 ${align === 'left' ? 'text-left' : 'text-right'} cursor-pointer select-none bg-gray-50 hover:bg-gray-100 ${sticky ? 'sticky top-0 z-20' : ''}`}
      onClick={() => onSort(col)}
    >
      <span className={`inline-flex ${align === 'left' ? '' : 'flex-row-reverse '}items-center gap-1`}>
        {label}
        {active ? (
          sortDir === 'asc'
            ? <ArrowUp className="h-3 w-3 text-primary-600" aria-hidden="true" />
            : <ArrowDown className="h-3 w-3 text-primary-600" aria-hidden="true" />
        ) : (
          <ArrowUpDown className="h-3 w-3 text-gray-400" aria-hidden="true" />
        )}
      </span>
    </th>
  );
}
